import React from 'react';
import PropTypes from 'prop-types';
import CustomStep from 'workOrderComponents/close/CustomStep';
import ChargesPanel from 'chargeComponents/ChargesPanel';
import ChargeSummary from 'chargeComponents/ChargeSummary';

class ChargesCloseStep extends React.Component {

    render() {
        const {
            workOrderActions,
            orderId,
            accountNumber,
            user,
            chargeActions,
            charges,
            stepConfig,
            orderCloseDetails,
            serviceTypeId,
            orderStatus,
            customerDetails,
            equipmentDetailsComplete
        } = this.props;

        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');
        const label = (
            <div style={{
                width: '100%'
            }}>
                <div>Charges</div>

            </div>
        );

        return (

            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={label}
                stepConfig={stepConfig}
                stepConfigKey="chargesStepConfig"
                orderCloseDetails={orderCloseDetails}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="charges">
                <div style={{
                    position: 'relative'
                }}>
                    <ChargeSummary
                        style={{
                        fontSize: '11px'
                    }}
                        charges={charges}/>

                    <ChargesPanel
                        paddingLeft="0"
                        paddingRight="0"
                        key="charges_panel"
                        header="Charges"
                        detailKey="charges"
                        user={user}
                        accountNumber={accountNumber}
                        chargeActions={chargeActions}
                        orderStatus={orderStatus}
                        orderId={orderId}
                        chargeOptionDetails={charges}
                        clearWorkOrderDetail={workOrderActions.clearWorkOrderDetail}
                        serviceTypeId={serviceTypeId}
                        customerDetails={customerDetails}
                        equipmentDetailsComplete={equipmentDetailsComplete}
                        />

                </div>

            </CustomStep>

        );

    }
}

ChargesCloseStep.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    accountNumber: PropTypes.string,
    user: PropTypes.object,
    chargeActions: PropTypes.object,
    charges: PropTypes.object,
    stepConfig: PropTypes.object,
    orderStatus: PropTypes.object,
    serviceTypeId: PropTypes.string,
    equipmentDetailsComplete: PropTypes.object
};

export default ChargesCloseStep;



// WEBPACK FOOTER //
// ./src/components/charges/ChargesCloseStep.js